import React, { useEffect, useState, useRef } from 'react';
import { MdPsychology } from 'react-icons/md';
import { FaLightbulb } from 'react-icons/fa';
import { FaClipboardList } from 'react-icons/fa';
import { FaPuzzlePiece } from "react-icons/fa6";
import { MdOutlineSwipe } from "react-icons/md";
import { TbDragDrop2 } from "react-icons/tb";
import {
  Box,
  Flex,
  Icon,
  List,
  ListItem,
  Textarea,
  Tooltip,
  Text,
  Input,
} from '@chakra-ui/react';
import Select from 'react-select';
import { MdAdd, MdDelete, MdOutlineStickyNote2 } from 'react-icons/md';
import { BiSolidDuplicate } from 'react-icons/bi';
import Menu from '../components/Navigate';

import StrightConector from '../components/dragNdrop/strightConector';
import { FaChartLine } from 'react-icons/fa';
import { TbHandClick, TbMessages } from 'react-icons/tb';
import { HiLink } from 'react-icons/hi';
import { IoAlert } from 'react-icons/io5';
import { FaAward } from 'react-icons/fa6';
import { MdAssessment } from 'react-icons/md';
import { MdOutlineAssessment } from 'react-icons/md';
interface PropsNote {
  showReflectionQuestions:any;
  formData?: any;
  reviews?: any;
  id?: number;
  language?: any;
  seq?: any;
  index?: number;
  handleNDI?: any;
  name?: any;
  handleInput?: any;
  input?: any;
  getSeq?: any;
  handleMiniNDI?: any;
  duplicateSeq?: any;
  delSeq?: any;
  alphabet?: any;
  setNavigation: any;
  handleBlock: any;
  items?: any;
  formDataGamelanguageCode?: any;
  handleSelectBlock?: any;
  showSelectBlock?: any;
  setSelectBlock?: any;
  validation?: any;
  currentseq?: any;
  ShowReview?: any;
  targetSequence?: any;
  blockOnFocusHanlder: any;
  blockOnBlurHanlder: any;
}
interface Block {
  blockPrimarySequence: string;
  // Add other properties as needed
  content: string | undefined; // Adjust the type according to your data structure
}

const scenarioOptions = Array.from({ length: 5 }, (_, i) => ({
  label: `Scenario ${i + 1}`,
  value: `Scenario ${i + 1}`,
}));

const NoteCompo: React.FC<PropsNote> = ({
  showReflectionQuestions,
  formData,
  targetSequence,

  seq,
  index,
  name,
  handleInput,
  input,
  getSeq,
  duplicateSeq,
  delSeq,

  setNavigation,
  handleBlock,
  handleSelectBlock,
  items,
  formDataGamelanguageCode,
  showSelectBlock,
  handleNDI,

  validation,
}) => {
  const textareaRef = useRef(null);

  // const [showScenarioCompletion, setshowScenarioCompletion] = useState(false);
  const [selectedScenario, setSelectedScenario] = useState<any>(null);

  // yash code
  // const [showScenarioCompletion, setshowScenarioCompletion] = useState(false);

  const [matchingBlockContent, setMatchingBlockContent] = useState('');

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [input?.[`Note${seq.input}`]?.note]);

  const customButtonStyles = {
    display: 'flex',
    alignItems: 'center',
    borderRadius: '15px',
    borderColor: '#ccc', // Optional: Change border color for disabled state
    borderWidth: '1px', // Add this line to set the border width
    borderStyle: 'solid', // Add this line to set the border style
    cursor: 'not-allowed', // Optional: Change cursor for disabled state
    padding: '5px 10px',
    width: '144px',
    // textAlign: "left",
    outerWidth: '10px',
    outline: 'none',
  };

  const customStyles = {
    menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
    control: (provided: any, state: any) => ({
      ...provided,
      borderRadius: '15px',
      borderColor: 'inherit',
      background: 'transparent',
      // height: '45px',
      width: '130px',
      padding: '0 !important',
    }),
  };

  const handleMiniNDInewblock = (value?: any, seq?: any, i?: any) => {
    handleNDI(value);

    const maxInputItem = items.reduce(
      (max: any, item: any) => (item.input > max.input ? item : max),
      items[0],
    );
    let input = maxInputItem?.input ? maxInputItem.input + 1 : 1;
    if (value !== '') {
      handleSelectBlock(
        { value: input },
        input,
        `Note${seq.input}`,
        `Note${seq.input}`,
      );
    }
  };
  const MiniBox1 = (props: {
    seq?: any;
    i?: number;
    name?: any;
    bodyRef?: any;
  }) => {
    const { seq, i, name, bodyRef } = props;
    return (
      <Box
        position={'absolute'}
        background={'#fff'}
        p={'10px'}
        boxShadow={'1px 1px 17px #69627914'}
        borderRadius={'8px'}
        zIndex={99}
        className="MiniShowBox"
      >
        <List cursor={'pointer'}>
          <ListItem
            onClick={() => handleMiniNDInewblock('Note', seq, i)}
            p={'10px'}
            display={'flex'}
            alignItems={'center'}
            borderBottom={'2px solid #f1f1f170'}
          >
            <Icon as={MdOutlineStickyNote2} mr={'10px'} color={'#3311db'} />
            Note
          </ListItem>

          <ListItem
            onClick={() => handleMiniNDInewblock('Dialog', seq, i)}
            p={'10px'}
            display={'flex'}
            alignItems={'center'}
            borderBottom={'2px solid #f1f1f170'}
          >
            <Icon as={TbMessages} mr={'10px'} color={'#3311db'} />
            Dialog
          </ListItem>
          <ListItem
            onClick={() => handleMiniNDInewblock('Interaction', seq, i)}
            p={'10px'}
            display={'flex'}
            alignItems={'center'}
          >
            <Icon as={TbHandClick} mr={'10px'} color={'#3311db'} />
            Interaction
          </ListItem>
          <ListItem
            onClick={() => handleMiniNDInewblock('Link', seq, i)}
            p={'10px'}
            display={'flex'}
            alignItems={'center'}
            borderBottom={'2px solid #f1f1f170'}
          >
            <Icon as={HiLink} mr={'10px'} color={'#3311db'} />
            Link
          </ListItem>
          {showReflectionQuestions && (
            <>
              <ListItem
                onClick={() => handleMiniNDInewblock('Reflection', seq, i)}
                p={'10px'}
                display={'flex'}
                alignItems={'center'}
                borderBottom={'2px solid #f1f1f170'}
              >
                <Icon as={MdPsychology} mr={'10px'} color={'#3311db'} />
                Reflection
              </ListItem>

              <ListItem
                onClick={() => handleMiniNDInewblock('Overview', seq, i)}
                p={'10px'}
                display={'flex'}
                alignItems={'center'}
                borderBottom={'2px solid #f1f1f170'}
              >
                <Icon as={FaClipboardList} mr={'10px'} color={'#3311db'} />
                Overview
              </ListItem>
              <ListItem
                onClick={() => handleMiniNDInewblock('KeyInsights', seq, i)}
                p={'10px'}
                display={'flex'}
                alignItems={'center'}
                borderBottom={'2px solid #f1f1f170'}
              >
                <Icon as={FaChartLine} mr={'10px'} color={'#3311db'} />
                KeyInsights
              </ListItem>
              <ListItem
                onClick={() => handleMiniNDInewblock('PreAssessment', seq, i)}
                p={'10px'}
                display={'flex'}
                alignItems={'center'}
                borderBottom={'2px solid #f1f1f170'}
              >
                <Icon as={MdAssessment} mr={'10px'} color={'#3311db'} />
                PreAssessment
              </ListItem>
              <ListItem
                onClick={() => handleMiniNDInewblock('PostAssessment', seq, i)}
                p={'10px'}
                display={'flex'}
                alignItems={'center'}
                borderBottom={'2px solid #f1f1f170'}
              >
                <Icon as={MdOutlineAssessment} mr={'10px'} color={'#3311db'} />
                PostAssessment
              </ListItem>
                              <ListItem
                           onClick={() => handleMiniNDInewblock('WehaveChoose', seq, i)}
                           p={'10px'}
                           display={'flex'}
                           alignItems={'center'}
                           borderBottom={'2px solid #f1f1f170'}
                         >
                           <Icon as={FaPuzzlePiece} mr={'10px'} color={'#3311db'} />
                           WehaveChoose
                         </ListItem>
                                    <ListItem
                           onClick={() => handleMiniNDInewblock('SwipeMiniGame', seq, i)}
                           p={'10px'}
                           display={'flex'}
                           alignItems={'center'}
                           borderBottom={'2px solid #f1f1f170'}
                         >
                           <Icon as={MdOutlineSwipe} mr={'10px'} color={'#3311db'} />
                           Swipe
                         </ListItem>
                                    <ListItem
                           onClick={() => handleMiniNDInewblock('DragForNow', seq, i)}
                           p={'10px'}
                           display={'flex'}
                           alignItems={'center'}
                           borderBottom={'2px solid #f1f1f170'}
                         >
                           <Icon as={TbDragDrop2} mr={'10px'} color={'#3311db'} />
                           Drag For Now 
                         </ListItem>
            </>
          )}
          {formData?.gameScenarioCompletion === 'true' && (
            <ListItem
              onClick={() =>
                handleMiniNDInewblock('ScenarioCompletion', seq, i)
              }
              p={'10px'}
              display={'flex'}
              alignItems={'center'}
              borderBottom={'2px solid #f1f1f170'}
            >
              <Icon as={FaAward} mr={'10px'} color={'#3311db'} />
              ScenarioCompletion
            </ListItem>
          )}
        </List>
      </Box>
    );
  };

  let focusSeqRef: any;
  const justClick = (event: any, seq: any) => {
    if (event.type === 'click') {
      focusSeqRef = document.getElementsByClassName(seq.id);
      const element = focusSeqRef?.[0];

      if (element) {
        element.classList.remove('non-caret');
        element.removeAttribute('readonly');
        element.focus();
      }
    }
  };

  return (
    <Flex padding={'10px 0'} alignItems={'start'} overflowY={'hidden'}>
      <Box className="block-action-icons">
        <Tooltip hasArrow label="Choose New Block">
          <div>
            <Icon
              as={MdAdd}
              transitionDelay={'0s !important'}
              fontSize={'18px'}
              color={'grey'}
              mr={'10px'}
              cursor={'pointer'}
              onClick={() => getSeq(seq, index, name)}
            />
          </div>
        </Tooltip>
        <Tooltip hasArrow label="Duplicate">
          <div>
            <Icon
              as={BiSolidDuplicate}
              transitionDelay={'0.1s !important'}
              fontSize={'18px'}
              color={'grey'}
              mr={'10px'}
              cursor={'pointer'}
              onClick={() =>
                duplicateSeq(seq, index, name, input?.[`Note${seq.input}`])
              }
            />
          </div>
        </Tooltip>
        <Tooltip hasArrow label="Delete Note">
          <div>
            <Icon
              as={MdDelete}
              transitionDelay={'0.2s !important'}
              fontSize={'18px'}
              color={'grey'}
              cursor={'pointer'}
              onClick={() => delSeq(seq, index, name)}
            />
          </div>
        </Tooltip>
      </Box>
      <Box
        className="block-id"
        mr={'10px'}
        w={'50px'}
        fontSize={'17px'}
        color={'#1b2559'}
        fontWeight={'700'}
      >
        {seq.id}
        {/* {`Note${seq.input}`} */}
      </Box>
      <Box
        className="box-block"
        w={{ base: '100%', lg: 'auto' }}
        flexDirection={{ base: 'column', lg: 'row' }}
        display={'flex'}
        alignItems={'center'}
      >
        <Box
          className="block-character-name"
          mr={'10px'}
          mb={{ base: '10px', lg: '0px' }}
          w={{ base: '100%', lg: '150px' }}
        >
          <button style={customButtonStyles} disabled={true} onClick={() => {}}>
            <span style={{ textAlign: 'left' }}>Narrator</span>
          </button>
        </Box>
        <Box
          className="block-input-text"
          mr={'10px'}
          mb={{ base: '10px', lg: '0px' }}
          w={{ base: '100%', lg: '400px' }}
        >

          <Input
  size="sm"
  mb="6px"
  placeholder="Enter short note..."
  name={`Note${seq.input}`}   // 🔥 Important: same naming pattern
  id="NoteSmall"              // Different id
  value={input?.[`Note${seq.input}`]?.smallNote || ''}
  onChange={handleInput}
  borderRadius="10px"
/>
          <Textarea
            ref={textareaRef}
            placeholder="Note"
            id="Note"
            className={`${seq.id}`}
            name={`Note${seq.input}`}
            onChange={handleInput}
            onClick={(e) => justClick(e, seq)}
            value={
              formDataGamelanguageCode
                ? matchingBlockContent
                : input?.[`Note${seq.input}`]?.note
            }
            isRequired={true}
            minHeight="65px"
            height={seq?.id === targetSequence?.id ? 'auto' : '65px !important'}
            borderRadius={'18px'}
            style={{
              overflow: 'hidden',
              border: validation?.[`Note${seq.input}`] && '2px solid red',
            }}
            overflow="auto" // Allow vertical scrolling
            _focusVisible={{
              borderColor: '#0000',
              border: '1px solid #e5e5e5',
              boxShadow: 'unset',
            }}
            tabIndex={0}
            readOnly={true}
          />
        </Box>

        <Box
          className="scenario-dropdown"
          mb="10px"
          w={{ base: '100%', lg: '200px' }}
        >
          <Text fontSize="13px" fontWeight="600" mb="4px" color="#1b2559">
            Select Scenario
          </Text>

          <Select
            placeholder="Select Scenario"
            options={scenarioOptions}
            // value={input?.[`Note${seq.input}`]?.scenario || null}

            value={
              scenarioOptions.find(
                (opt) => opt.value === input?.[`Note${seq.input}`]?.scenario,
              ) || null
            }
            styles={{
              ...customStyles,
              control: (provided: any) => ({
                ...provided,
                borderRadius: '12px',
                minHeight: '36px',
              }),
            }}
            onChange={(option: any) =>
              handleInput({
                name: `Note${seq.input}`,
                value: {
                  // scenario: option,
                  scenario: option?.value,
                },
              })
            }
            isSearchable={false}
            menuPortalTarget={document.body}
          />
        </Box>
        {/* <Box
  className="scenario-dropdown"
  mb="10px"
  w={{ base: '100%', lg: '200px' }}
>
  <Text fontSize="13px" fontWeight="600" mb="4px" color="#1b2559">
    Select Scenario
  </Text>

  <Select
    placeholder="Select Scenario"
    options={scenarioOptions}
    value={selectedScenario}
    onChange={(option: any) => setSelectedScenario(option)}
    styles={{
      ...customStyles,
      control: (provided: any) => ({
        ...provided,
        borderRadius: '12px',
        minHeight: '36px',
      }),
    }}
    isSearchable={false}
    menuPortalTarget={document.body}
  />
</Box> */}

        <Box
          className="navigation-icon"
          h={'100%'}
          display={'flex'}
          alignItems={'center'}
          mr={'40px'}
          width={'auto'}
        >
          <Flex>
            <Box>
              <Tooltip hasArrow label="Add Navigations">
                <div>
                  <Menu
                    tabState={'leadDialog'}
                    id={seq.input}
                    for={`Note${seq.input}`}
                    setNavigation={setNavigation}
                    handleBlock={handleBlock}
                    items={items}
                    seq={seq}
                  />
                </div>
              </Tooltip>
            </Box>
            <Box
              ml={'4px'}
              cursor={'pointer'}
              display={
                input?.[`Note${seq.input}`]?.NoteleadShow ? 'block' : 'none'
              }
              zIndex={9999}
            >
              {input?.[`Note${seq.input}`]?.NoteleadShow === 'New Block' &&
              !input?.[`Note${seq.input}`]?.Notenavigate ? (
                <>
                  <MiniBox1 seq={seq} i={index} />
                </>
              ) : input?.[`Note${seq.input}`]?.NoteleadShow ===
                  'Select Block' &&
                !input?.[`Note${seq.input}`]?.Notenavigate ? (
                // Render select tag for Select Block
                <Select
                  placeholder={'Blocks...'}
                  id="Dialog"
                  name={`Note${seq.input}`}
                  menuPortalTarget={document.body}
                  styles={customStyles}
                  options={showSelectBlock.filter(
                    (option: any) => option.value !== seq.input,
                  )}
                  isSearchable={true}
                  className="react-select"
                  value={
                    showSelectBlock.find(
                      (option: any) =>
                        option.value ==
                        input?.[`Note${seq.input}`]?.Notenavigate,
                    ) || null
                  }
                  onChange={(e: any) =>
                    handleSelectBlock(
                      e,
                      seq.input,
                      `Note${seq.input}`,
                      `Note${seq.input}`,
                    )
                  }
                />
              ) : (
                // Render content for the 'else' condition
                <>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <StrightConector
                      name={
                        input?.[`Note${seq.input}`]?.NoteleadShow ===
                        'New Block'
                          ? showSelectBlock.find(
                              (option: any) =>
                                option.value ==
                                input?.[`Note${seq.input}`]?.Notenavigate,
                            )?.label
                          : input?.[`Note${seq.input}`]?.NoteleadShow ===
                            'Select Block'
                          ? showSelectBlock.find(
                              (option: any) =>
                                option.value ==
                                input?.[`Note${seq.input}`]?.Notenavigate,
                            )?.label
                          : input?.[`Note${seq.input}`]?.Notenavigate
                      }
                    />
                  </div>
                </>
              )}
            </Box>
          </Flex>
        </Box>
      </Box>
    </Flex>
  );
};

export default NoteCompo;
